<script setup lang="ts">
import { mdiChevronLeft } from "@mdi/js";
import { CalendarPrev, useForwardProps, type CalendarPrevProps } from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";
import Button from "../button/Button.vue";
import { Icon } from "../icon";

interface Props extends Omit<CalendarPrevProps, "as" | "asChild">, ClassProps {}
const props = defineProps<Props>();

const delegatedProps = useDelegatedProps(props);
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<CalendarPrev asChild v-bind="forwardedProps">
		<Button
			:class="cn('w-fit px-1 opacity-50 hover:opacity-100', props.class)"
			variant="ghost"
			size="sm"
		>
			<slot>
				<Icon :d="mdiChevronLeft" />
			</slot>
		</Button>
	</CalendarPrev>
</template>
